import React from "react";

const ArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M12.2516 6.41829H0.584961M6.41829 0.584961L0.584961 6.41829L6.41829 12.2516"
        stroke="black"
        stroke-width="1.17"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowLeft;
